function convertToPost(date) {
	return this.$moment(date).format()
}

export default convertToPost
